export const breadcrumb = {
  dashboard: 'Dashboard',
  profile: 'Profile',
  logout: 'Logout',
  document: {
    index: 'Documents',
    create: 'Add document'
  },
  payment: {
    index: 'Payments'
  },
  price: {
    index: 'Rates'
  }
};
